import { FC } from "react";
import { Header2 } from "./skins/header-2";
import { Header3 } from "./skins/header-3";
import { TemplateType } from "@commons-monorepo/index";
import { HeaderProps } from "./types";

const MainHeaderSsr: FC<HeaderProps> = ({
  notFound,
  categories,
  hasWholesale,
  hasServices,
  hasOffers,
  theme,
  partnerId,
  ownerId,
  isPrime,
  data,
  isPortraitInView,
  goToCheckout,
  partnerWithPrivateDomain,
  t,
}) => {
  return (
    <>
      {theme?.template?.HEADER?.SKIN === TemplateType.HEADER_4 && (
        <Header2
          notFound={notFound}
          overBanner={!!theme?.template?.HEADER?.PROPS?.OVER_BANNER}
          sticky={!!theme.template.HEADER.PROPS.STICKY}
          categories={categories}
          hasOffers={hasOffers}
          hasServices={hasServices}
          hasWholesale={hasWholesale}
          partnerId={partnerId}
          ownerId={ownerId}
          isPrime={isPrime}
          theme={theme}
          data={data}
          partnerWithPrivateDomain={partnerWithPrivateDomain}
          isPortraitInView={isPortraitInView}
          t={t}
          goToCheckout={goToCheckout}
        />
      )}
      {theme?.template?.HEADER?.SKIN === TemplateType.HEADER_5 && (
        <Header3
          notFound={notFound}
          overBanner={!!theme?.template?.HEADER?.PROPS?.OVER_BANNER}
          sticky={!!theme?.template?.HEADER?.PROPS?.STICKY}
          categories={categories}
          hasOffers={hasOffers}
          hasServices={hasServices}
          hasWholesale={hasWholesale}
          partnerId={partnerId}
          ownerId={ownerId}
          isPrime={isPrime}
          theme={theme}
          data={data}
          partnerWithPrivateDomain={partnerWithPrivateDomain}
          isPortraitInView={isPortraitInView}
          t={t}
          goToCheckout={goToCheckout}
        />
      )}
    </>
  );
};

export default MainHeaderSsr;
